import { reducer } from './duck';
import { IModule } from '../rootInterfaces/root.interface';

export { CrossSelector } from './container';

export const crossModule: IModule = {
  moduleName: 'cross',
  reducer,
};
